import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
  color?: string
}

const BirthIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      id='Layer_1' enableBackground='new 0 0 512 512' height={props.width} viewBox='0 0 512 512'
      width={props.width} fill={props.color || theme.palette.text.primary}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          d='m120.041 440.303c5.688 8.221 12.156 15.999 19.386 23.229 31.255 31.255 72.655 48.468 116.573 48.468s85.318-17.213 116.573-48.468 48.468-72.655 48.468-116.573v-94.273z'
        />
        <path
          d='m154.128 251.673c2.79-11.033 7.498-21.322 14.172-31.003-8.314-12.6-13.986-27.087-16.225-42.671h-.035c-8.284 0-15-6.716-15-15s6.716-15 15-15h.035c7.303-50.816 51.12-89.999 103.925-89.999s96.623 39.183 103.924 90h.117c8.284 0 15 6.716 15 15s-6.716 15-15 15h-.117c-2.242 15.603-7.926 30.107-16.257 42.719 7.295 10.724 12.548 22.648 15.516 35.173l61.857-38.557v-52.293c0-43.918-17.213-85.318-48.468-116.573-31.253-31.256-72.654-48.469-116.572-48.469s-85.318 17.213-116.573 48.468-48.468 72.655-48.468 116.573v37.822z'
        />
        <path d='m90.959 240.776v106.183c0 23.511 4.938 46.299 14.318 67.197l116.274-72.475z' />
        <path
          d='m331.693 273.027c-.974-10.196-4.023-20.077-8.918-29.054-18.16 15.003-41.433 24.027-66.775 24.027-25.393 0-48.709-9.062-66.886-24.12-4.824 8.76-7.365 18.078-7.935 28.695l67.529 52.177z'
        />
        <path
          d='m256 238c41.355 0 75-33.645 75-75 0-36.346-25.992-66.727-60.362-73.556 2.242 11.273 10.68 20.283 21.907 23.181 8.021 2.07 12.847 10.251 10.776 18.272-1.746 6.764-7.838 11.255-14.514 11.255-1.241 0-2.502-.155-3.759-.479-23.503-6.065-40.928-25.508-44.393-49.532-.123-.852-.155-1.694-.134-2.526-33.782 7.117-59.252 37.035-59.508 72.844.006.181.027.358.027.54 0 .183-.021.36-.027.541.294 41.106 33.813 74.46 74.987 74.46z'
        />
      </g>
    </svg>
  )
}
export default BirthIcon
